module.exports = "\n<div v-on:click=\"OpenInputFile\">\n  <slot></slot>\n</div>\n<input\n        style=\"display: none\"\n        id=\"{{ id || name }}\"\n        type=\"file\"\n        name=\"{{ name }}\"\n        v-bind-boolean:multiple=\"multiple\"\n        @change=\"fileInputChange\"\n>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/clubs/uploadFiles.vue
// module id = 517
// module chunks = 11